// extracted by mini-css-extract-plugin
export default {"container":"surveyConfirmation_container__IfbLX","primary-button":"surveyConfirmation_primary-button__GRt9o","link":"surveyConfirmation_link__Neaot"};